import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.jiwon');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-jiwon',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.jiwon/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageJiwonComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    // ── 상태 ─────────────────────────────────────────────────────────────────
    public step: number = 0;

    public survey: {
        age: number | null;
        employment: string;
        income: string;
        credit: string;
        purpose: string;
    } = { age: null, employment: '', income: '', credit: '', purpose: '' };

    public programs: any[] = [];
    public expandedAiId: string | null = null;
    public aiLoading: { [id: string]: boolean } = {};
    public aiResults: { [id: string]: any } = {};
    public compareList: any[] = [];
    public showCompareModal: boolean = false;
    public compareRows = [
        { key: 'type',       label: '유형' },
        { key: 'limit_text', label: '한도' },
        { key: 'rate_text',  label: '금리' },
        { key: 'institution', label: '기관' },
        { key: 'target',     label: '대상' },
        { key: 'url',        label: '신청' },
    ];

    // ── 설문 옵션 정의 ────────────────────────────────────────────────────────
    public surveyOptions = {
        employment: [
            { value: 'job_seeker', icon: '🔍', label: '취업준비생 / 무직',   desc: '구직 중이거나 현재 소득이 없는 경우' },
            { value: 'employee',   icon: '💼', label: '직장인 (근로자)',      desc: '정규직·계약직·파트타임 포함' },
            { value: 'freelancer', icon: '💻', label: '프리랜서 / 단기근로', desc: '사업자 없는 자유 계약 형태' },
            { value: 'self_employed', icon: '🏪', label: '자영업자 / 소상공인', desc: '사업자 등록이 되어 있는 경우' },
        ],
        income: [
            { value: 'low',      label: '1,500만원 이하',      desc: '연 소득 약 125만원/월 이하',    badge: '저소득 우대' },
            { value: 'mid_low',  label: '1,500 ~ 3,500만원',  desc: '연 소득 약 125~290만원/월',     badge: '서민금융 가능' },
            { value: 'mid_high', label: '3,500 ~ 5,000만원',  desc: '연 소득 약 290~415만원/월',     badge: '청년 제도 가능' },
            { value: 'high',     label: '5,000만원 이상',      desc: '연 소득 약 415만원/월 이상',    badge: '일부 제한' },
        ],
        credit: [
            { value: 'unknown', label: '잘 모름',             desc: '앱에서 무료 조회 가능' },
            { value: 'low',     label: '낮음  (~579점)',       desc: 'NICE/KCB 기준' },
            { value: 'mid_low', label: '중하  (580~664점)',    desc: 'NICE/KCB 기준' },
            { value: 'mid_high',label: '중상  (665~749점)',    desc: 'NICE/KCB 기준' },
            { value: 'high',    label: '높음  (750점+)',       desc: 'NICE/KCB 기준' },
        ],
        purpose: [
            { value: 'living',  icon: '🛒', label: '생활비 / 긴급자금' },
            { value: 'housing', icon: '🏠', label: '전월세 / 주거비' },
            { value: 'startup', icon: '🚀', label: '창업 / 사업자금' },
            { value: 'savings', icon: '💰', label: '저축 / 자산형성' },
        ],
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    // ── 네비게이션 ────────────────────────────────────────────────────────────
    public start() {
        this.step = 1;
        this.service.render();
    }

    public back() {
        if (this.step > 1) {
            this.step--;
            this.service.render();
        }
    }

    public reset() {
        this.step = 0;
        this.survey = { age: null, employment: '', income: '', credit: '', purpose: '' };
        this.programs = [];
        this.expandedAiId = null;
        this.aiLoading = {};
        this.aiResults = {};
        this.compareList = [];
        this.showCompareModal = false;
        this.service.render();
    }

    public canNext(): boolean {
        if (this.step === 1) return !!this.survey.age && this.survey.age > 0;
        return true;
    }

    public nextStep() {
        if (!this.canNext()) return;
        this.step++;
        this.service.render();
    }

    // ── 입력 핸들러 ───────────────────────────────────────────────────────────
    public setAge(event: Event) {
        const val = parseInt((event.target as HTMLInputElement).value, 10);
        this.survey.age = isNaN(val) ? null : val;
        this.service.render();
    }

    public selectAge(age: number) {
        this.survey.age = age;
        this.service.render();
    }

    public async selectOption(field: keyof typeof this.survey, value: string) {
        (this.survey as any)[field] = value;
        await this.service.render();

        // 고용/소득/신용/목적 선택 즉시 다음 스텝
        const autoAdvance = ['employment', 'income', 'credit', 'purpose'];
        if (autoAdvance.includes(field)) {
            await this._sleep(200);
            if (field === 'purpose') {
                await this.submit();
            } else {
                this.step++;
                await this.service.render();
            }
        }
    }

    // ── 설문 제출 ─────────────────────────────────────────────────────────────
    public async submit() {
        this.step = 6;
        await this.service.render();

        const res = await wiz.call('match', {
            age:        this.survey.age,
            employment: this.survey.employment,
            income:     this.survey.income,
            credit:     this.survey.credit,
            purpose:    this.survey.purpose,
        });

        this.programs = (res.code === 200 && res.data) ? res.data : [];
        this.step = 7;
        await this.service.render();
    }

    // ── AI 분석 토글 ──────────────────────────────────────────────────────────
    public async toggleAiExplain(program: any) {
        if (this.expandedAiId === program.id) {
            this.expandedAiId = null;
            await this.service.render();
            return;
        }

        this.expandedAiId = program.id;
        await this.service.render();

        if (this.aiResults[program.id]) return;

        this.aiLoading[program.id] = true;
        await this.service.render();

        const res = await wiz.call('ai_explain', {
            program_data: JSON.stringify(program),
            user_data:    JSON.stringify(this.survey),
        });

        this.aiLoading[program.id] = false;
        this.aiResults[program.id] = (res.code === 200) ? res.data : {
            why_match: '분석 중 오류가 발생했습니다.',
            documents: [],
            tips: '',
            agent_type: 'error',
        };
        await this.service.render();
    }

    // ── 비교 기능 ─────────────────────────────────────────────────────────────
    public isCompared(program: any): boolean {
        return this.compareList.some(p => p.id === program.id);
    }

    public toggleCompare(program: any) {
        const idx = this.compareList.findIndex(p => p.id === program.id);
        if (idx >= 0) {
            this.compareList.splice(idx, 1);
        } else if (this.compareList.length < 3) {
            this.compareList.push(program);
        }
        this.service.render();
    }

    public openCompare() {
        this.showCompareModal = true;
        this.service.render();
    }

    public closeCompare() {
        this.showCompareModal = false;
        this.service.render();
    }

    // ── 유틸 ──────────────────────────────────────────────────────────────────
    public getTypeClass(type: string): string {
        const map: { [key: string]: string } = {
            '대출':  'bg-blue-100 text-blue-700',
            '적금':  'bg-emerald-100 text-emerald-700',
            '지원금': 'bg-violet-100 text-violet-700',
        };
        return map[type] || 'bg-slate-100 text-slate-600';
    }

    private _sleep(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

export default PageJiwonComponent;